import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

export const sxStyles = {
  heroBg: {
    overflow: 'hidden',
    // TODO add color to library
    backgroundColor: '#F9F9F9',
  },
  heroTitle: {
    marginTop: '1rem',
    marginBottom: '1.5rem',
  },
  heroSubtitle: {
    maxWidth: '620px',
    lineHeight: '2rem',
    fontSize: '1.25rem',
  },
  heroActionsWrap: {
    display: 'flex',
    maxHeight: '48px',
    marginTop: '3rem',
    marginBottom: '2rem',
  },
  capitalize: {
    textTransform: 'capitalize',
  },
};

export const StyledHeroSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'end',
  maxWidth: '1320px',
  margin: '0 auto',
  position: 'relative',

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

export const StyledSchoolDetailsBtn = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '308px',
  minWidth: '172px',
  width: '100%',
  marginRight: '0.5rem',
  padding: '0 0.5rem',
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  fontSize: '1rem',
  fontWeight: 600,
  transition: 'color 0.5s, background-color 0.5s',

  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export const StyledWebsiteLink = styled('a')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '308px',
  width: '100%',
  fontWeight: 600,
  padding: '0.75rem 0',
  color: theme.palette.primary.main,
  borderRadius: '4px',

  '& > svg:first-of-type': {
    marginRight: '0.75rem',
  },

  '&:hover': {
    // TODO add color to library
    backgroundColor: '#EBF6F7',
  },

  [theme.breakpoints.up('sm')]: {
    padding: '0.75rem 1rem',
  },
}));

export const StyledHeroText = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  maxWidth: '620px',
  width: '100%',
  minHeight: 'auto',
  padding: '0 1.25rem',

  [theme.breakpoints.up('sm')]: {
    minHeight: '480px',
  },
}));

export const StyledHeroImg = styled('div')(({ theme }) => ({
  maxWidth: '850px',
  width: '100%',
  margin: '1.5rem auto 0 auto',

  img: {
    position: 'static',
    display: 'block',
    margin: '0 auto',
    borderBottomLeftRadius: '240px',
    maxHeight: '480px',
    height: '100%',
  },

  [theme.breakpoints.up('lg')]: {
    width: '850px',
    margin: '0',

    img: {
      position: 'relative',
      left: '74px',
    },
  },

  [theme.breakpoints.up('xl')]: {
    img: {
      position: 'relative',
      left: '256px',
    },
  },
}));
